const iniFc=4e3
const iniThickness=15

export default function AnchorConcreteClass() { 
    this.fc = iniFc, 
    this.thickness = iniThickness, 
    this.barsCrossTensionFailure = !1, 
    this.barsPreventTensionBreakout = !1, 
    this.shearXNumber4Bars = !1, 
    this.shearXStirrups = !1, 
    this.shearXNoBreakout = !1, 
    this.shearYNumber4Bars = !1, 
    this.shearYStirrups = !1, 
    this.shearYNoBreakout = !1 
} 